import styled from 'styled-components';
import { spacing, font, colors, themes } from '@chegg-ui/theme';
import { Button, SecondaryButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import { Modal } from '@chegg-ui/modal';
import { NotificationBanner } from '@chegg-ui/notification-banner';
export var Container = styled.div.withConfig({
  componentId: "sc-dbrhac-0"
})(["display:flex;flex-direction:column;gap:", ";font-family:", ";align-items:center;position:relative;padding:", " ", " ", " ", ";"], spacing.px32, font.family["default"], spacing.px64, spacing.px64, spacing.px112, spacing.px64);
export var Popup = styled(Modal).withConfig({
  componentId: "sc-dbrhac-1"
})(["div[role='dialog'] > div:first-child{padding:0;}"]);
export var SendEmailDescription = styled.div.withConfig({
  componentId: "sc-dbrhac-2"
})(["font-size:", ";line-height:", ";letter-spacing:", ";"], font.size.px16, themes.horizon.font.lineHeight.md, themes.horizon.font.letterSpacing.md);
export var DisplayEmail = styled.div.withConfig({
  componentId: "sc-dbrhac-3"
})(["font-size:", ";font-weight:", ";line-height:", ";letter-spacing:", ";display:grid;grid-template-columns:auto auto;gap:", ";align-items:center;> svg{margin-bottom:2px;}"], font.size.px16, font.weight.bold, themes.horizon.font.lineHeight.sm, themes.horizon.font.letterSpacing.md, spacing.px8);
export var SendEmailFooter = styled.div.withConfig({
  componentId: "sc-dbrhac-4"
})(["font-size:", ";line-height:", ";text-align:center;"], font.size.px14, spacing.px16);
export var MFALink = styled(Link).withConfig({
  componentId: "sc-dbrhac-5"
})(["font-size:", ";line-height:", ";color:", " !important;text-decoration:underline !important;cursor:pointer;"], font.size.px14, spacing.px16, colors.grey900);
export var ContactUsLink = styled(Link).withConfig({
  componentId: "sc-dbrhac-6"
})(["font-size:", ";line-height:", ";font-weight:", ";"], font.size.px14, spacing.px16, font.weight.bold);
export var CloseModalLink = styled(Link).withConfig({
  componentId: "sc-dbrhac-7"
})(["font-size:", ";font-weight:", ";cursor:pointer;"], font.size.px14, font.weight.bold);
export var ContentContainer = styled.div.withConfig({
  componentId: "sc-dbrhac-8"
})(["display:flex;flex-direction:column;gap:", ";align-items:center;"], spacing.px16);
export var PopupHeader = styled.h2.withConfig({
  componentId: "sc-dbrhac-9"
})(["font-weight:", ";text-align:center;line-height:", ";margin:0;font-size:", ";line-height:1.1;letter-spacing:", ";"], font.weight.bold, spacing.px40, font.size.px32, themes.horizon.font.letterSpacing.lg);
export var PopupError = styled.div.withConfig({
  componentId: "sc-dbrhac-10"
})(["color:", ";display:block;margin:", " auto;width:fit-content;font-family:", ";height:", ";font-size:", ";"], colors.coral, spacing.px12, font.family["default"], spacing.px16, font.size.px14);
export var ActionButton = styled(Button).withConfig({
  componentId: "sc-dbrhac-11"
})(["font-size:", ";width:60%;margin:0;"], font.size.px18);
export var PasswordInputElement = styled.div.withConfig({
  componentId: "sc-dbrhac-12"
})(["height:", ";input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none !important;margin:0 !important;}"], function (props) {
  return props.fullHeight ? '100%' : spacing.px48;
});
export var PasswordVisibilityButton = styled(SecondaryButton).withConfig({
  componentId: "sc-dbrhac-13"
})(["position:relative;font-size:", ";top:-", ";padding-top:", ";outline:none;right:-7rem;background:transparent;:active{outline:none;background:transparent;}"], font.size.px12, spacing.px64, spacing.px12);
export var ValidateCodeDescription = styled.div.withConfig({
  componentId: "sc-dbrhac-14"
})(["font-size:", ";font-family:", ";text-align:center;line-height:", ";letter-spacing:", ";"], font.size.px16, font.family["default"], themes.horizon.font.lineHeight.md, themes.horizon.font.letterSpacing.md);
export var ValidateCodeFooter = styled.div.withConfig({
  componentId: "sc-dbrhac-15"
})(["text-align:center;font-size:", ";font-family:", ";line-height:", ";margin:0 ", " ", ";display:flex;flex-direction:column;"], font.size.px14, font.family["default"], spacing.px24, spacing.px32, spacing.px32);
export var ValidateCodeError = styled(PopupError).withConfig({
  componentId: "sc-dbrhac-16"
})(["margin:", " auto 0;text-align:center;height:unset;"], spacing.px8);
export var ValidateCodeActionButton = styled(ActionButton).withConfig({
  componentId: "sc-dbrhac-17"
})(["padding:", " ", ";margin:0 auto !important;"], spacing.px8, spacing.px48);
export var ValidateCodeLink = styled(Link).withConfig({
  componentId: "sc-dbrhac-18"
})(["font-size:", ";cursor:pointer;font-weight:", ";"], font.size.px14, font.weight.bold);
export var ErrorBanner = styled(NotificationBanner).withConfig({
  componentId: "sc-dbrhac-19"
})(["width:auto;div:first-child{align-items:center;}"]);
export var FooterBanner = styled(NotificationBanner).withConfig({
  componentId: "sc-dbrhac-20"
})(["position:absolute;bottom:0;left:0;width:100%;border-top-left-radius:0;border-top-right-radius:0;"]);